function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
var _templateObject, _templateObject2;
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _taggedTemplateLiteral(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
import "../../../../node_modules/.pnpm/@lit_reactive-element@2.1.1/node_modules/@lit/reactive-element/reactive-element.js";
import { html as o } from "../../../../node_modules/.pnpm/lit-html@3.3.1/node_modules/lit-html/lit-html.js";
import "../../../../node_modules/.pnpm/lit-element@4.2.1/node_modules/lit-element/lit-element.js";
import { customElement as l } from "../../../../node_modules/.pnpm/@lit_reactive-element@2.1.1/node_modules/@lit/reactive-element/decorators/custom-element.js";
import { NjcGuidedNav as c } from "../../guided-nav.js";
import "../../../list/gator/list/list.gator.js";
import "../../../list/gator/list-item/list-item.gator.js";
import "../guided-nav-step/guided-nav-step.gator.js";
import "../guided-nav-substep/guided-nav-substep.gator.js";
import { toasterService as a } from "../../../../services/toaster-service.js";
var h = Object.getOwnPropertyDescriptor,
  S = function S(e, t, r, s) {
    for (var i = s > 1 ? void 0 : s ? h(t, r) : t, n = e.length - 1, p; n >= 0; n--) (p = e[n]) && (i = p(i) || i);
    return i;
  };
var u = /*#__PURE__*/function (_c) {
  function u() {
    _classCallCheck(this, u);
    return _callSuper(this, u, arguments);
  }
  _inherits(u, _c);
  return _createClass(u, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      _superPropGet(u, "connectedCallback", this, 3)([]), this._createToaster();
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;
      return o(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n            <div class=\"ngc-guided-nav\">\n                <ngc-list aria-label=\"Guided Navigation Steps\">\n                    ", "\n                </ngc-list>\n            </div>\n        "])), this.steps.map(function (e) {
        return o(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n                        <ngc-guided-nav-step\n                            .step=\"", "\"\n                            .state=\"", "\"\n                            .onStepSelected=\"", "\"\n                            .onSubstepSelected=\"", "\"\n                            .selectedStep=\"", "\"\n                            .badgeContent=\"", "\"\n                            selectable\n                        ></ngc-guided-nav-step>\n                    "])), e, _this._getStepState(e), _this._handleStepSelected.bind(_this), _this._handleSubstepSelected.bind(_this), _this.selectedStep, e.badgeContent || null);
      }));
    }
  }, {
    key: "_getStepState",
    value: function _getStepState(e) {
      var _this$steps$complete, _this$steps;
      if (e.substeps && e.substeps.length > 0) {
        var _e$substeps$length, _e$substeps, _e$substeps$filter$le, _e$substeps2;
        var s = (_e$substeps$length = (_e$substeps = e.substeps) === null || _e$substeps === void 0 ? void 0 : _e$substeps.length) !== null && _e$substeps$length !== void 0 ? _e$substeps$length : 0,
          i = (_e$substeps$filter$le = (_e$substeps2 = e.substeps) === null || _e$substeps2 === void 0 ? void 0 : _e$substeps2.filter(function (d) {
            return d.complete;
          }).length) !== null && _e$substeps$filter$le !== void 0 ? _e$substeps$filter$le : 0,
          n = i > 0 && i < s;
        return i === s ? "complete" : n ? "current" : "incomplete";
      }
      var r = !((_this$steps$complete = (_this$steps = this.steps[this.steps.indexOf(e) - 1]) === null || _this$steps === void 0 ? void 0 : _this$steps.complete) !== null && _this$steps$complete !== void 0 ? _this$steps$complete : !1);
      return e.complete ? "complete" : r ? "incomplete" : "current";
    }
  }, {
    key: "_handleStepSelected",
    value: function _handleStepSelected(e, t) {
      e.preventDefault(), e.stopPropagation(), this._moveToStep(t);
    }
  }, {
    key: "_handleSubstepSelected",
    value: function _handleSubstepSelected(e, t) {
      e.preventDefault(), this._moveToSubstep(t);
    }
  }, {
    key: "_moveToStep",
    value: function _moveToStep(e) {
      var _e$substeps$0$id, _e$substeps3;
      if (this.forwardNavigationDisabled) {
        var t = this._getStepState(e);
        if (!(t === "current" || t === "complete")) {
          this._showForwardNavigationErrorToast();
          return;
        }
      }
      this._dispatchChangeEvent({
        step: e.id,
        substep: (_e$substeps$0$id = (_e$substeps3 = e.substeps) === null || _e$substeps3 === void 0 || (_e$substeps3 = _e$substeps3[0]) === null || _e$substeps3 === void 0 ? void 0 : _e$substeps3.id) !== null && _e$substeps$0$id !== void 0 ? _e$substeps$0$id : null
      });
    }
  }, {
    key: "_moveToSubstep",
    value: function _moveToSubstep(e) {
      if (this.forwardNavigationDisabled && !this._isSubstepCompleteOrNext(e)) {
        this._showForwardNavigationErrorToast();
        return;
      }
      this._dispatchChangeEvent(_objectSpread(_objectSpread({}, this.selectedStep), {}, {
        substep: e.id
      }));
    }
  }, {
    key: "_isSubstepCompleteOrNext",
    value: function _isSubstepCompleteOrNext(e) {
      var _this2 = this,
        _t$substeps;
      if (e.complete) return !0;
      var t = this.steps.find(function (s) {
        var _this2$selectedStep;
        return s.id === ((_this2$selectedStep = _this2.selectedStep) === null || _this2$selectedStep === void 0 ? void 0 : _this2$selectedStep.step);
      });
      return !t || !t.substeps ? !1 : (t === null || t === void 0 || (_t$substeps = t.substeps) === null || _t$substeps === void 0 ? void 0 : _t$substeps.findIndex(function (s) {
        return s.complete === !1;
      })) - 1 === t.substeps.indexOf(e) - 1;
    }
  }, {
    key: "_createToaster",
    value: function _createToaster() {
      if (document.querySelector("ngc-toaster")) return;
      var e = document.createElement("ngc-toaster");
      e.position = "bottom-right", e.defaultToastOptions = {
        duration: 5e3,
        dismissible: !0
      }, document.body.appendChild(e);
    }
  }, {
    key: "_showForwardNavigationErrorToast",
    value: function _showForwardNavigationErrorToast() {
      a.error(this.forwardNavigationDisabledErrorMessage);
    }
  }, {
    key: "_dispatchChangeEvent",
    value: function _dispatchChangeEvent(e) {
      var t = new CustomEvent("change", {
        composed: !0,
        bubbles: !0,
        detail: {
          value: e
        }
      });
      this.dispatchEvent(t);
    }
  }, {
    key: "moveToNextStep",
    value: function moveToNextStep() {
      var _this3 = this,
        _this$selectedStep;
      var e = this.steps.find(function (r) {
        var _this3$selectedStep;
        return r.id === ((_this3$selectedStep = _this3.selectedStep) === null || _this3$selectedStep === void 0 ? void 0 : _this3$selectedStep.step);
      });
      if (!e) return;
      if (e.substeps && e.substeps.length > 0 && (_this$selectedStep = this.selectedStep) !== null && _this$selectedStep !== void 0 && _this$selectedStep.substep) {
        var r = e.substeps.findIndex(function (i) {
            var _this3$selectedStep2;
            return i.id === ((_this3$selectedStep2 = _this3.selectedStep) === null || _this3$selectedStep2 === void 0 ? void 0 : _this3$selectedStep2.substep);
          }),
          s = e.substeps[r + 1];
        if (s) {
          this._moveToSubstep(s);
          return;
        }
      }
      var t = this.steps[this.steps.indexOf(e) + 1];
      t && this._moveToStep(t);
    }
  }, {
    key: "moveToPreviousStep",
    value: function moveToPreviousStep() {
      var _this4 = this,
        _this$selectedStep2,
        _t$substeps$id,
        _t$substeps2;
      var e = this.steps.find(function (r) {
        var _this4$selectedStep;
        return r.id === ((_this4$selectedStep = _this4.selectedStep) === null || _this4$selectedStep === void 0 ? void 0 : _this4$selectedStep.step);
      });
      if (!e) return;
      if (e.substeps && e.substeps.length > 0 && (_this$selectedStep2 = this.selectedStep) !== null && _this$selectedStep2 !== void 0 && _this$selectedStep2.substep) {
        var r = e.substeps.findIndex(function (i) {
            var _this4$selectedStep2;
            return i.id === ((_this4$selectedStep2 = _this4.selectedStep) === null || _this4$selectedStep2 === void 0 ? void 0 : _this4$selectedStep2.substep);
          }),
          s = e.substeps[r - 1];
        if (s) {
          this._moveToSubstep(s);
          return;
        }
      }
      var t = this.steps[this.steps.indexOf(e) - 1];
      t && this._dispatchChangeEvent({
        step: t.id,
        substep: (_t$substeps$id = (_t$substeps2 = t.substeps) === null || _t$substeps2 === void 0 || (_t$substeps2 = _t$substeps2[t.substeps.length - 1]) === null || _t$substeps2 === void 0 ? void 0 : _t$substeps2.id) !== null && _t$substeps$id !== void 0 ? _t$substeps$id : null
      });
    }
  }, {
    key: "getCurrentStepProgress",
    value: function getCurrentStepProgress() {
      var _this5 = this,
        _this$selectedStep3,
        _e$substeps4;
      var e = this.steps.find(function (n) {
        var _this5$selectedStep;
        return n.id === ((_this5$selectedStep = _this5.selectedStep) === null || _this5$selectedStep === void 0 ? void 0 : _this5$selectedStep.step);
      });
      if (!e) return 0;
      var t = this.steps.indexOf(e),
        r = this.steps.slice(0, t).reduce(function (n, p) {
          var _p$substeps;
          return n + (((_p$substeps = p.substeps) === null || _p$substeps === void 0 ? void 0 : _p$substeps.length) || 1);
        }, 0);
      var s = 0;
      if ((_this$selectedStep3 = this.selectedStep) !== null && _this$selectedStep3 !== void 0 && _this$selectedStep3.substep && (_e$substeps4 = e.substeps) !== null && _e$substeps4 !== void 0 && _e$substeps4.length) {
        var n = e.substeps.findIndex(function (p) {
          var _this5$selectedStep2;
          return p.id === ((_this5$selectedStep2 = _this5.selectedStep) === null || _this5$selectedStep2 === void 0 ? void 0 : _this5$selectedStep2.substep);
        });
        n > -1 && (s = n);
      }
      return (r + s) / this._totalStepsAndSubsteps * 100;
    }
  }]);
}(c);
u = S([l("ngc-guided-nav")], u);
export { u as NgcGuidedNav };